import { Injectable } from "@angular/core";
import { RestService } from "./rest-service";

import { Url_Base } from 'app/rest-constants';
import { MmcPrintDispatch } from "app/models/mmc/mmc-print-dispatch";

const Url_UploadProduct = "/buchanan/upload-product";
const Url_Print = "/buchanan/print";
const Url_BulkPrint = "/buchanan/bulk-print";

@Injectable()
export class BuchananService {

  /** Constructor */
  constructor(
    private restService: RestService
  ) { }


  /**
   * Calls the Buchanan API used to upload the given File as Product Data
   */
  public uploadProductFile(productFile: File): Promise<void> {
    // Build the FormData which is used to send the File to the API
    const formData = new FormData();
    formData.append("product_file", productFile);

    // Call the API
    const url = `${Url_Base}${Url_UploadProduct}`;
    return this.restService.upload<void>(url, formData);
  }

  /**
   * Calls the Buchanan API used to print quantities of a single Item Code.
   */
  public print(dto: BuchananPrintDto): Promise<MmcPrintDispatch> {
    // Call the API 
    const url = `${Url_Base}${Url_Print}`;
    console.log("DTO - " + JSON.stringify(dto));
    return this.restService.post<MmcPrintDispatch>(url, dto);
  }
 
  /** 
   * Calls the Buchanan API used to print quantities of multiple Item Codes specified in a CSV File. 
   */
  public bulkPrint(dto: BuchananBulkPrintDto, dataFile: File): Promise<MmcPrintDispatch> {
    // Build the FormData which is used to call the API with
    const formData = new FormData();
    formData.append("print_file", dataFile);
    formData.append("dto", JSON.stringify(dto));
    
    // Call the API
    const url = `${Url_Base}${Url_BulkPrint}`;
    return this.restService.upload<MmcPrintDispatch>(url, formData);
  }

  /** 
   * Calls the Buchanan API used to print quantities of multiple Item Codes specified in a CSV File. 
   */
  public bulkPrint2(dto: BuchananBulkPrintDto, dataFile: File): Promise<MmcPrintDispatch> {
    // Build the FormData which is used to call the API with
    const formData = new FormData();
    formData.append("print_file", dataFile);
    
    // Call the API
    const url = `${Url_Base}${Url_BulkPrint}-2?printer=${dto.printer}`;
    return this.restService.upload<MmcPrintDispatch>(url, formData);
  }

}

/**
 * DTO used to call the "Bulk Print" API
 */
export interface BuchananPrintDto {
  /** Item Code reference to the GRAI being printed */
  item_code: string;

  /** Printer to print with */
  printer: string;

  /** Number of labels to print */
  quantity: number;

  /** PO Number  */
  po: string;

  /** Family Name */
  family_name: string;

  /** Warehouse */
  warehouse: string;
}

/**
 * DTO used to call the "Print" API
 */
export interface BuchananBulkPrintDto {
  /** Printer to print with */
  printer: string;
}
